import { newAxiosIns } from '@/libs/axios'

export const apiDahsboardKomchat = ({
  search,
  limit,
  offset,
  status,
  productType,
}) => newAxiosIns.get(
  `/auth/api/v1/admin/dashboard/komchat/partner?search=${search}&limit=${limit}&offset=${offset}&status=${status}&product_type=${productType}`,
)

export const apiVerifiedGrowthKomchat = ({ start_date, end_date }) => newAxiosIns.get('/auth/api/v1/admin/dashboard/komchat/user-verified-growth', {
  params: { start_date, end_date },
})
export const apiRegisteredGrowthKomchat = ({ start_date, end_date }) => newAxiosIns.get(
  '/auth/api/v1/admin/dashboard/komchat/user-registered-growth',
  { params: { start_date, end_date } },
)
export const apiActivePartnerKomchat = ({ start_date, end_date }) => newAxiosIns.get(
  '/auth/api/v1/admin/dashboard/komchat/active-partner',
  { params: { start_date, end_date } },
)
export const apiBroadcastGrowthKomchat = ({ start_date, end_date }) => newAxiosIns.get('/komchat-api/api/v1/dashboard/admin/user-broadcast-growth', {
  params: { start_date, end_date },
})
export const apiRevenueGrowthKomchat = ({ start_date, end_date }) => newAxiosIns.get('/komship/api/v1/admin/whatsapp/revenue', {
  params: { start_date, end_date },
})
export const apiDownloadPartnerKomchat = ({
  start_date,
  end_date,
  status,
  product_type,
  service,
}) => newAxiosIns.get('/auth/api/v1/admin/dashboard/komchat/export', {
  responseType: 'blob',
  params: {
    start_date, end_date, status, product_type, service,
  },
})
export const apiDetailRevenue = date => {
  const params = { date }
  return newAxiosIns.get('/komship/api/v1/admin/whatsapp/detail-revenue', { params })
}
export const apiClosingOrderKomchat = ({ start_date, end_date }) => newAxiosIns.get('/komchat-api/api/v1/dashboard/admin/closing', {
  params: { start_date, end_date },
})
export const apiBroadcastKomchat = ({ start_date, end_date }) => newAxiosIns.get('/komchat-api/api/v1/dashboard/admin/broadcast', {
  params: { start_date, end_date },
})
export const apiSubscriptionDetailKomchat = ({ start_date, end_date }) => newAxiosIns.get('/komship/api/v1/admin/whatsapp/detail-revenue', {
  params: { start_date, end_date },
})
export const apiClosingOrderDetailKomchat = ({ start_date, end_date }) => newAxiosIns.get('/komchat-api/api/v1/dashboard/admin/detail-closing', {
  params: { start_date, end_date },
})
export const apiBroadcastDetailKomchat = ({ start_date, end_date }) => newAxiosIns.get('/komchat-api/api/v1/dashboard/admin/detail-broadcast', {
  params: { start_date, end_date },
})
export const apiDetailPartnerKomchat = id => newAxiosIns.get(`/komchat-api/api/v1/dashboard/admin/detail-partner/${id}`)

export const apiDataSpending = ({ startDate, endDate }) => newAxiosIns.get('/komchat-api/api/v1/dashboard/admin/data-spending', {
  params: { start_date: startDate, end_date: endDate },
})
export const apiDataTokens = ({ startDate, endDate }) => newAxiosIns.get('/komchat-api/api/v1/dashboard/admin/data-tokens', {
  params: { start_date: startDate, end_date: endDate },
})
export const apiDataUserActive = ({ startDate, endDate }) => newAxiosIns.get('/komchat-api/api/v1/dashboard/admin/data-user-active', {
  params: { start_date: startDate, end_date: endDate },
})
export const apiDataTotalLeads = ({ startDate, endDate }) => newAxiosIns.get('/komchat-api/api/v1/dashboard/admin/data-total-leads', {
  params: { start_date: startDate, end_date: endDate },
})
export const apiDataConversionRate = ({ startDate, endDate }) => newAxiosIns.get('/komchat-api/api/v1/dashboard/admin/data-conversion-rate', {
  params: { start_date: startDate, end_date: endDate },
})
export const apiDataDistributeToken = ({ startDate, endDate }) => newAxiosIns.get('/komchat-api/api/v1/dashboard/admin/data-distribute-token', {
  params: { start_date: startDate, end_date: endDate },
})
export const apiDataPayment = ({ startDate, endDate }) => newAxiosIns.get('/komchat-api/api/v1/dashboard/admin/data-payment', {
  params: { start_date: startDate, end_date: endDate },
})
export const apiDataActivity = ({
  startDate, endDate, eventType, limit, offset,
}) => newAxiosIns.get('/komchat-api/api/v1/dashboard/admin/data-activity', {
  params: {
    start_date: startDate, end_date: endDate, event_type: eventType, limit, offset,
  },
})
export const apiDataClosing = ({ startDate, endDate }) => newAxiosIns.get('/komchat-api/api/v1/dashboard/admin/data-closing', {
  params: { start_date: startDate, end_date: endDate },
})
export const apiDataAgents = ({ startDate, endDate }) => newAxiosIns.get('/komchat-api/api/v1/dashboard/admin/data-agents', {
  params: { start_date: startDate, end_date: endDate },
})

export const apiExportAiKomchat = ({ start_date, end_date }) => newAxiosIns.get('/komchat-api/api/v1/dashboard/admin/export', {
  responseType: 'blob',
  params: { start_date, end_date },
})

export const apiDeleteNumberKomchat = (userId, payload) => newAxiosIns.delete(`/komchat-api/api/v1/dashboard/admin/delete-number/${userId}`, {
  data: payload,
})
export const apiExpirePartnerKomchat = partnerId => newAxiosIns.put(`/komship/api/v1/admin/whatsapp/expired/${partnerId}`)
export const apiUpdateStatusPartnerKomchat = apiExpirePartnerKomchat
